import React, { Component } from 'react'
// import './noplate.css'
import { fire } from '../../config/firebase'

//animation
import AOS from 'aos';
import 'aos/dist/aos.css';

export default class NoPlate extends Component {
  
    state={
        name:'',
        dob:'',
        id:'',
        zip:'',
        city:'',
        state:'',
        street:'',
        location:'',
        college:'',
        shift:'',
        vanPlate:'',
        photo:'',
        dob_error:'',
        state_error:'',
        city_error:"",
        street_error:"",
        location_error:"",
        vanPlate_error:"",
        edit:false,
        lat:'',
        lng:'',
    }

    componentDidMount(){
        const user = JSON.parse(localStorage.getItem('van'))
if(user){

    let data = fire.firestore().collection('vanRegistration');
    data.onSnapshot(snap=>{
        snap.forEach(val=>{
            if(val.id === user.uid){
                this.setState({
                    name:val.data().name,
                    id:val.data().id,
                    zip:val.data().zip,
                    city:val.data().city,
                    state:val.data().state,
                    street:val.data().street,
                    location:val.data().location,
                    college:val.data().college,
                    shift:val.data().shift,
                    vanPlate:val.data().placa,
                    photo:val.data().photo,
                })
            }
        })
    })

    //getting_location
    navigator.geolocation.getCurrentPosition((location) => {
        this.setState({
                lat: location.coords.latitude,
                lng: location.coords.longitude
            })
        });


}else{
    alert('Please Login first..')
    this.props.history.push('/')
}
    }


    done(){
       let { name, id, zip, city, state, street, location, college, shift,lat,lng,
        vanPlate, user_data, } = this.state

let newdata = {
    name, id, zip, city, state, street, location:{lat,lng}, placa:vanPlate,
}
const user = JSON.parse(localStorage.getItem('van'))

let data = fire.firestore().collection('vanRegistration').doc(user.uid);
data.update(newdata).then(()=>{
    alert('Edit Successfull')
    this.setState({
        edit:false
    })
}).catch(e=>{
    alert('Error : '+e.message)
})
    }


    vanPlate = async (value) =>{
        this.setState({vanPlate:value})
        let possibilty_1 = /\b([a-z]{3})-([0-9]{4})\b/
        let test_1 = possibilty_1.test(value.toLowerCase());
        console.log('test_1',test_1)
        if(test_1 ){
            this.setState({
                vanPlate:value.toLowerCase(),vanPlate_error:''
            })
        }else{
            this.setState({vanPlate_error:value+' Is not a correct format. Correct format is XXX-1111.  '})
        }
    }

     //_________________CEP_______________//
     cep = async (value) =>{
          
        let possibilty_1 = /\b([0-9]{2}).([0-9]{3})-([0-9]{3})\b/
        let test_1 = possibilty_1.test(value.toLowerCase());
        console.log('test_1',test_1)
        if(test_1 ){
            this.setState({
                zip:value.toLowerCase(),zip_error:''
            })
        }else{
            this.setState({zip_error:value?value+' Is not a correct format. Correct format is XX.XXX-XXX.  ':"Correct format is XX.XXX-XXX."})
        }
    }


    render() {
       let { user_data } = this.state;
       AOS.init({duration:1000})

       let { 
        name,
        // dob,
        id,
        zip,
        city,
        state,
        street,
        vanPlate,
        dob_error,
        state_error,
           city_error,
           street_error,
           shift_error,
           vanPlate_error,
           photo,edit
    } = this.state
       
        return (
            <div className='main'>
                <div className='nn_header'>
                    <h1>Arriba!</h1>
                </div>
                <div onClick={()=>{this.props.history.goBack()}} style={{cursor:'pointer',marginLeft:'6%',fontSize:'20px',color:'red'}}>{"< De volta"}</div>
                {/* _________________________________________BODY____________________________________ */}
                <div className='profile_body'>
                    {!edit &&
                    <div className='p_main'>
                        <img src={photo} width='200' height='200' alt={name}/>
                        <p className='user_name'>{"Nome : " +name}</p>
                        <p className='user_name'>{"Placa : " +vanPlate}</p>
                        <p className='user_name'>{"Estado : " +state}</p>
                        <p className='user_name'>{"Cidade : " +city}</p>
                        <p className='user_name'>{"Rua : " +street}</p>
                        <p className='user_name'>{"CEP : " +zip}</p>
                        <button onClick={()=>{this.setState({edit:true})}} className="edit_profile_btn">Editar Perfil</button>
                        </div>
                    }

                    {edit &&
                    <div style={{alignSelf:'center'}}>
                            <div className='form' style={{maxWidth:'800px',alignSelf:'center'}}>
                                <h3 style={{color:'coral'}}>Editando Formulário</h3>


                      <div className='inputs'>
                      <div className='inp'>
                      <label>Nome</label>
                      <input type="text" readOnly  value={name?name:user_data &&user_data.name} placeholder='Enter your name '/> 
                          </div>
                      {/* <div className='inp'>

                      {!dob_error ?<label>Aniversário</label>
:<label style={{color:'red'}}>{dob_error}</label>}
                      <input type="date" value={dob} onChange={(event)=>{this.setState({dob:event.target.value})}} placeholder='Aniversário'/> 
                      </div> */}

                     

                      <div className='inp'>
                      {!city_error ?<label>Cidade</label>
:<label style={{color:'red'}}>{city_error}</label>}
                      <input value={city} maxLength='30' onChange={(event)=>{this.setState({city:event.target.value})}} type="text" placeholder='Cidade'/> 
                      </div>

                      <div className='inp'>
                      {!state_error ?<label>Estado</label>
:<label style={{color:'red'}}>{state_error}</label>}
                      <input value={state} maxLength='30' onChange={(event)=>{this.setState({state:event.target.value})}} type="text" placeholder='Estado'/> 
                      </div>

                      <div className='inp'>
                      {!street_error ?<label>Rua</label>
:<label style={{color:'red'}}>{street_error}</label>}
                      <input value={street} maxLength='25' onChange={(event)=>{this.setState({street:event.target.value})}} type="text" placeholder='Rua'/> 
                      </div>

                   
                      <div className='inp'>
                      {!shift_error ?<label>Turno</label>
:<label style={{color:'red'}}>{shift_error}</label>}
                      {/* <input onChange={(event)=>{this.setState({shift:event.target.value})}} type="text" placeholder='Turno'/> */}
                      <select  style={{border:'1px solid coral',width:'93%',maxWidth:'550px'}} onChange={(event)=>{this.setState({shift:event.target.value})}} className='input'>
                          <option >Manha</option>
                          <option >Tarde</option>
                          <option>Noite</option>
                      </select>
                      </div>

                      <div className='inp'>
                      {!vanPlate_error ?<label>Placa da Van</label>
:<label style={{color:'red'}}>{vanPlate_error}</label>}
                      <input value={vanPlate} onChange={(event)=>{this.vanPlate(event.target.value)}} type="text" placeholder=' jfv-1233'/> 
                      </div>
                      <div className='inp'>
                      <button onClick={()=>{this.done()}} style={{float:'right',alignSelf:'flex-end'}} className="edit_profile_btn">Feita</button>
                      </div>
                      </div>

                       

                   </div>
                    </div>
                    }
                </div>
                {/* _______________________________________BODY_END____________________________________ */}
              
                <div className='n_footer'>
                    <h3>Thank you for using Arriba!</h3>
                </div>
            </div>
        )
    }
}
